export default {
  title: 'PROVIDER ARRIVAL/COMPLETED PROXIMITY SETTINGS',
  items: {
    ShowArrivedAndCompletedButtons: {
      label: 'Show Arrived and Complete Buttons',
      type: 'boolean'
    },
    ArrivalProximityRadius: {
      label: 'Arrival Proximity Radius',
      type: 'integer',
      unit: 'miles'
    },
    CompletedProximityRadius: {
      label: 'Completed Proximity Radius',
      type: 'integer',
      unit: 'miles'
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Settings/settings-config/provider-arrival-completed-proximity.js